"use client";

import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useDemoMode } from "@/components/demo/DemoModeProvider";

export { useDemoMode } from "@/components/demo/DemoModeProvider";

export function DemoMaskedText({
  children,
  className,
  as = "span",
}: {
  children: ReactNode;
  className?: string;
  as?: "span" | "div";
}) {
  const demo = useDemoMode();
  const Component = as;

  return (
    <Component
      className={cn(
        demo && "select-none blur-[4px]",
        className,
      )}
      aria-hidden={demo ? true : undefined}
    >
      {children}
    </Component>
  );
}
